import styled from "styled-components";

export const DatePickerStyled = styled.div`
  flex-direction: column;
  width: 100%;
  /* margin: 5px 0px; */
  display: flex;

  .ant-picker {
    width: 100%;
    height: 36px; // Adjust height to match the TextFieldStyle if needed
    background: #ffffff;
    color: #2b3952;
    line-height: 18px;
    border-radius: 3px;

    .ant-picker-input {
      border: none !important;
    }

    input {
      z-index: 1;
      height: 36px;
      border: none !important;
      padding: 6.5px 11px;
      &:focus {
        outline: none;
        border-color: #00b0cc !important;
      }
    }

    &.ant-picker-focused {
      .ant-picker-input {
        border-color: #00b0cc !important;
      }
    }

    &.ant-picker-disabled {
      cursor: default;
      opacity: 0.8;
      .ant-picker-input {
        opacity: 0.8;
      }
    }
  }

  .label {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  .note {
    color: #301d35;
    font-size: 11px;
    font-weight: 400;
  }
`;
